import React from "react";
import { Link } from "react-router-dom";

import "./index.css";

const Index = () => {
  return (
    <div id="indexPage">
      <div className="row">
        <div className="col s12 m12 l6 xl6 center-align">
          <div className="intro">
            Hi! I'm
            <br />
            Aayush :)
            <br />
            -- a developer
          </div>
          <div className="row IndexNavigation">
            <Link className="col s12 m4 l4 xl4 btn cta" to="/works">
              View My Works
            </Link>
            <Link
              className="col s12 m4 l4 xl4 black-text btn white"
              to="/skills"
            >
              My Skills
            </Link>
            <Link
              className="col s12 m4 l4 xl4 black-text btn white"
              to="/contact"
            >
              Contact me
            </Link>
          </div>
          <hr />
          <a href="http://github.com/aa1aac" className="icon" target="new">
            <i className="fa fa-github"></i>
          </a>{" "}
          <a
            href="https://medium.com/@aayush.acharya"
            className="icon"
            target="new"
          >
            <i className="fa fa-medium"></i>
          </a>
        </div>
        <div className="col l6 xl6 hide-on-med-and-down indexSecond "></div>
      </div>
    </div>
  );
};

export default Index;
